import getActionClauseTypeOptions from './getActionClauseTypeOptions';
import getConditionalExceptionClauseTypeOptions from './getConditionalExceptionClauseTypeOptions';
import getExistingClauseTypesInSection from 'owa-inbox-rules-option/lib/actions/helpers/getExistingClauseTypesInSection';
export default function hasUsedAllClauseTypesInSection(sectionType) {
    var numExistingClauseTypes = getExistingClauseTypesInSection(sectionType).size;
    if (sectionType == 'conditional' || sectionType == 'exception') {
        return getConditionalExceptionClauseTypeOptions().length == numExistingClauseTypes;
    }
    else if (sectionType == 'action') {
        return getActionClauseTypeOptions().length == numExistingClauseTypes;
    }
    else {
        throw new Error('Cannot determine max number of clauses for unknown section type');
    }
}
//# sourceMappingURL=hasUsedAllClauseTypesInSection.js.map